//@flow

import styled from "styled-components"
import theme from "../Theme"

const Note = styled.p`
  color: ${props => props.theme.accent};
  font-size: 1.1rem;
  font-style: italic;
  line-height: 1.2em;
  margin: 1rem 0 1rem 0;
`

Note.defaultProps = { theme }

export default Note



// WEBPACK FOOTER //
// ./src/UI/Form/Note.js